export function formatBytes(bytes: number, decimals: number = 2, lang = 'en'): string {
   const prettyBytes = require('pretty-bytes');
   return prettyBytes(bytes, { maximumFractionDigits: decimals, locale: lang });
}

export function base64ToByteCount(base64string: string) {
   const characterCount: number = base64string.length;
   const paddingCount: number = (base64string.substr(characterCount - 2).match(new RegExp('=', 'g')) || []).length;
   return 3 * (characterCount / 4) - paddingCount;
}

export function toBase64(str: string) {
   return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (p1) => String.fromCharCode(parseInt(p1, 16))));
}

export function htmlToBase64(str: string) {
   return btoa(unescape(encodeURIComponent(str)));
}

export function base64toBlob(b64Data: string, contentType = '', sliceSize = 512) {
   const byteCharacters = atob(b64Data);
   const byteArrays = [];

   for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
         byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
   }

   const blob = new Blob(byteArrays, { type: contentType });
   return blob;
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
   let binary = '';

   const bytes = new Uint8Array(buffer);
   const len = bytes.byteLength;

   for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
   }

   return btoa(binary);
}
